<fieldset  class="fieldset"  *ngIf="paymentForm.controls">
<legend> פרטי העברה
</legend>
<div [formGroup]="paymentForm" style="margin: 0 auto;">
  <table class="table table-border">
    <thead class="text-nowrap">
      <th>תאריך העברה</th>
      <th>מס' בנק</th>
      <th>מס' סניף</th>
      <th>מס' חשבון</th>
      <th>מס' אסמכתא</th>
      <th>סוג העברה</th>
    </thead>
    <tbody>
      <ng-container>
        <tr>
          <td>
            <date-input [withJewishDate]="false" [withLabel]="false" [placeholder]="'תאריך העברה:'"
              [dateControl]="paymentForm.controls.doneOn">Loading...</date-input>
          </td>
          <td>
            <input class="form-control narrow" formControlName="bankNumber" apply-enter />
          </td>
          <td>
            <input class="form-control narrow" formControlName="bankBranchNumber" apply-enter />
          </td>
          <td>
            <input class="form-control narrow" formControlName="bankAcountNumber" apply-enter />
          </td>
          <td>
            <input class="form-control narrow" formControlName="transferReference" apply-enter />
          </td>
          <td>
             <mat-select apply-enter class="form-control" placeholder="סוג העברה" formControlName="transferType">
            <mat-option [value]="null">...</mat-option>
            <mat-option [value]="1">ACH</mat-option>
            <mat-option [value]="2">Zelle</mat-option>
            <mat-option [value]="3">Wire</mat-option>
          </mat-select>
          </td>

        </tr>

      </ng-container>
    </tbody>
  </table>
  <span style="color: blue;">יש להכניס מס' אסמכתא המופיע בחשבון העמותה</span>
</div>
</fieldset>
